
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    balance: 'Home',
    cases: 'Cases',
    games: 'Games',
    inventory: 'Inventory',
    referrals: 'Friends',
    profile: 'Profile',
    menu: 'Menu',
    settings: 'Settings',
    wiki: 'Skin wiki',
  },
  ru: {
    balance: 'Главная',
    cases: 'Кейсы',
    games: 'Игры',
    inventory: 'Инвентарь',
    referrals: 'Друзья',
    profile: 'Профиль',
    menu: 'Меню',
    settings: 'Настройки',
    wiki: 'Вики скинов',
  },
  uz: {
    balance: 'Asosiy',
    cases: 'Keyslar',
    games: 'Oʻyinlar',
    inventory: 'Inventar',
    referrals: 'Doʻstlar',
    profile: 'Profil',
    menu: 'Menyu',
    settings: 'Sozlamalar',
    wiki: 'Skinlar vikisi',
  },
  fa: {
    balance: 'خانه',
    cases: 'کیس‌ها',
    games: 'بازی‌ها',
    inventory: 'انبار',
    referrals: 'دوستان',
    profile: 'پروفایل',
    menu: 'منو',
    settings: 'تنظیمات',
    wiki: 'ویکی اسکین‌ها',
  },
  pt: {
    balance: 'Início',
    cases: 'Caixas',
    games: 'Jogos',
    inventory: 'Inventário',
    referrals: 'Amigos',
    profile: 'Perfil',
    menu: 'Menu',
    settings: 'Configurações',
    wiki: 'Wiki de skins',
  },
  tr: {
    balance: 'Ana sayfa',
    cases: 'Kasalar',
    games: 'Oyunlar',
    inventory: 'Envanter',
    referrals: 'Arkadaşlar',
    profile: 'Profil',
    menu: 'Menü',
    settings: 'Ayarlar',
    wiki: 'Skin vikisi',
  },
});
